export default "__VITE_ASSET__UrCz1Juc__"